"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _oneWeir = require("@weirgroup/one-weir");
var _languageMsg = _interopRequireDefault(require("./languageMsg"));
var _inviteusersModule = _interopRequireDefault(require("./inviteusers.module.css"));
var _addteammember = _interopRequireDefault(require("../addteammember"));
var _sendinvitation = _interopRequireDefault(require("../sendinvitation"));
var _manageYourTeam = require("../manageYourTeam.action");
class InviteUsers extends _react.default.Component {
  static renderStepItem(step, index) {
    return /*#__PURE__*/_react.default.createElement(_oneWeir.MilestoneStep, {
      selected: step.selected,
      active: step.active,
      key: index,
      label: step.name,
      onClick: step.click
    });
  }
  constructor(props) {
    super(props);
    this.removeUser = user => {
      const index = this.state.assignedUsersList.indexOf(user);
      const usersListAssigned = this.state.assignedUsersList;
      if (index > -1) {
        usersListAssigned.splice(index, 1);
      }
      this.setState({
        usersListAssigned
      });
    };
    this.state = {
      breadcrumbHistoryData: [],
      milestoneSteps: [{
        step: 0,
        name: _languageMsg.default.SELECT_ROLE_AND_TEAM_MEMBERS,
        active: true,
        selected: false,
        click: () => {}
      }, {
        step: 1,
        name: _languageMsg.default.SEND_INVITATION_STEP,
        active: false,
        selected: false,
        click: () => {}
      }],
      milestoneStepsState: 0,
      assignedUsersList: [],
      selectedAppRole: '',
      sendInvitationState: false
    };
    this.renderAddTeamPanel = this.renderAddTeamPanel.bind(this);
    this.renderSendInvitationPanel = this.renderSendInvitationPanel.bind(this);
    this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
    this.handleSendInvitationClick = this.handleSendInvitationClick.bind(this);
    this.handleChangeAppRole = this.handleChangeAppRole.bind(this);
  }
  componentDidMount() {
    this.breadcrumbInitialize();
    this.determineMilestoneWorkflow();
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.sendInvitationStateValue !== prevState.sendInvitationStateValue) {
      return {
        sendInvitationStateValue: nextProps.sendInvitationStateValue
      };
    }
    return null;
  }
  componentDidUpdate(prevProps) {
    if (this.props.sendInvitationStateValue !== prevProps.sendInvitationStateValue) {
      this.setState({
        milestoneSteps: [{
          step: 0,
          name: _languageMsg.default.SELECT_ROLE_AND_TEAM_MEMBERS,
          active: true,
          selected: false,
          click: () => {}
        }, {
          step: 1,
          name: _languageMsg.default.SEND_INVITATION_STEP,
          active: false,
          selected: false,
          click: () => {}
        }],
        milestoneStepsState: 0,
        assignedUsersList: [],
        selectedAppRole: '',
        sendInvitationState: true
      }, () => {
        this.props.sendInvitationState(false);
        this.props.setUserDetails([]);
        this.determineMilestoneWorkflow();
      });
    }
  }
  breadcrumbInitialize() {
    const breadcrumbHistoryData = [];
    breadcrumbHistoryData.push({
      path: '#',
      title: _languageMsg.default.MANAGE_YOUR_TEAM,
      callbackHandler: () => this.props.navCallback(0)
    });
    breadcrumbHistoryData.push({
      path: '#',
      title: this.props.mineSiteLabel.singular,
      callbackHandler: () => this.props.navCallback(1)
    });
    breadcrumbHistoryData.push({
      path: '#',
      title: _languageMsg.default.INVITE_TEAM_MEMBERS
    });
    this.setState({
      breadcrumbHistoryData
    });
  }
  determineMilestoneWorkflow() {
    const steps = this.state.milestoneSteps;
    for (let i = 0; i < steps.length; i += 1) {
      steps[i].click = () => {
        if (steps[i].selected) {
          this.resetActiveStatus();
          if (steps[i] === i) {
            steps[i].active = true;
          }
          this.setState({
            milestoneStepsState: steps[i].step
          });
        }
      };
    }
    this.setState({
      milestoneSteps: steps
    });
  }
  resetActiveStatus() {
    const mSteps = this.state.milestoneSteps;
    for (let i = 0; i < mSteps.length; i += 1) {
      mSteps[i].active = false;
    }
    this.setState({
      milestoneSteps: mSteps
    });
  }
  handleNextButtonClick(assignedUsersList) {
    this.setState({
      assignedUsersList
    });
    const steps = this.state.milestoneSteps;
    const milestoneStepsState = this.state.milestoneStepsState;
    this.resetActiveStatus();
    steps[this.state.milestoneStepsState].selected = true;
    steps[this.state.milestoneStepsState + 1].active = true;
    this.setState({
      milestoneSteps: steps,
      milestoneStepsState: milestoneStepsState + 1
    });
  }
  handleSendInvitationClick() {
    this.state.assignedUsersList.forEach(user => {
      const reqBody = {
        UserEmail: user,
        AppObjectId: this.props.appinfo.appid,
        AppRoleId: this.state.selectedAppRole.appRoleObjectId,
        BusinessEntityObjectId: this.props.selectedBusinessEntity.businessEntityObjectId
      };
      this.props.sendInvitation(reqBody);
    });
  }
  handleChangeAppRole(selectedAppRole) {
    this.setState({
      selectedAppRole
    });
  }
  renderAddTeamPanel() {
    return /*#__PURE__*/_react.default.createElement(_addteammember.default, {
      handleNextButtonClick: this.handleNextButtonClick,
      handleChangeAppRole: this.handleChangeAppRole,
      selectedAppRole: this.state.selectedAppRole,
      assignableUserList: this.props.assignableUserList !== undefined ? this.props.assignableUserList.assignableUsers : [],
      selectedUsersList: this.state.assignedUsersList,
      appId: this.props.appinfo.appid
    });
  }
  renderSendInvitationPanel() {
    return /*#__PURE__*/_react.default.createElement(_sendinvitation.default, {
      onClickSendInvitation: this.handleSendInvitationClick,
      assignUsersValues: this.state.assignedUsersList,
      removeUser: user => this.removeUser(user),
      selectedAppRole: this.state.selectedAppRole,
      selectedBusinessEntity: this.props.selectedBusinessEntity
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "invite-users-page",
      className: _inviteusersModule.default.wrapper
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "invite-users-breadcrumb"
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.Breadcrumb, {
      breadcrumbHistory: this.state.breadcrumbHistoryData
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _inviteusersModule.default.mBottom
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "invite-users-title",
      className: _inviteusersModule.default.viewUsersHeading
    }, this.props.selectedBusinessEntity !== undefined ? this.props.selectedBusinessEntity.sourceSystemBusinessEntityDisplayName : '')), /*#__PURE__*/_react.default.createElement("div", {
      className: _inviteusersModule.default.milestoneWrapper
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.MilestoneNavigation, null, this.state.milestoneSteps.map((step, index) => InviteUsers.renderStepItem(step, index)))), /*#__PURE__*/_react.default.createElement("div", {
      className: _inviteusersModule.default.panels
    }, this.state.milestoneStepsState === 0 ? this.renderAddTeamPanel() : '', this.state.milestoneStepsState === 1 ? this.renderSendInvitationPanel() : ''));
  }
}
function mapDispatchToProps(dispatch) {
  return {
    sendInvitation: data => {
      dispatch((0, _manageYourTeam.sendInvitation)(data));
    },
    sendInvitationState: stateVal => {
      dispatch((0, _manageYourTeam.sendInvitationState)(stateVal));
    },
    setUserDetails: val => {
      dispatch((0, _manageYourTeam.setUserDetails)(val));
    }
  };
}
const mapStateToProps = state => ({
  usersList: state.manageYourTeam.usersList,
  sendInvitationStateValue: state.manageYourTeam.sendInvitationState,
  appinfo: state.manageYourTeam.appinfo,
  assignableUserList: state.manageYourTeam.assignableUsers,
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InviteUsers);